namespace Core {

    const template = `
        <lightbox 
            show="showPopup"
            close="close({isSuccess: showSuccess})"
            hide-header-bar="true"
            modal-overlay-class="signup-popup"
            >
            <div class="signup-popup-container" ng-style="styles">
                <div class="close-button" ng-click="close({isSuccess: showSuccess})">&#x2715;</div>
                <div class="left-form-cell">
                    <div class="title">{{showSuccess ? successMessage : titleLabel}}</div>
                    <button ng-if="showSuccess" ng-click="continue()">{{continueButtonLabel}}</button>
                    <newsletter-sign-up-popup-form 
                        ng-if="!showSuccess"
                        primary-button="true" 
                        on-success="confirm()"></newsletter-sign-up-popup-form>
                    <div class="unsubscription-notes"  ng-bind-html="unsubscriptionNotes"></div>
                </div>
            </div>
        </lightbox>
    `;

    export class SignUpPopupService {
        private signUpPopupBackgroundImageUrl: string;

        constructor(
           private basePopupService: Core.BasePopupService,
           private resourceService: Core.ResourceService,
           protected analytics: any
        ) {
            this.signUpPopupBackgroundImageUrl = this._getBackgroundImageUrl();
        }

        private _getBackgroundImageUrl() {
            let backgroundUrl;
            const configValue = TRPCONFIG.Domain2.SignUpPopupBackgroundUrl;
            try {
                let cfg = JSON.parse(configValue);
                backgroundUrl = TRPCONFIG.Rtl ? cfg.RightToLeft : cfg.LeftToRight;
            } catch(err) {}

            return backgroundUrl || configValue;
        }

        private _sendPopupClosedGAEvent({value}) {
            if (!value || !value.isSuccess) {
                this.analytics.trackEvent({
                    category: 'newsletterSignup',
                    action: 'click',
                    label: 'PopUp_Closed',
                    dimension9: 'newsletterSignup'
                });
            }
        }

        public showPopup(): ng.IPromise<any> {
            return this.basePopupService.showPopup(template, {popupScope:
                    {
                        showSuccess: false,
                        continueButtonLabel: this.resourceService.get('CONTINUE'),
                        successMessage: this.resourceService.get('NEWSLETTERSIGNUPREGISTRATIONSUCCESSFUL'),
                        titleLabel: this.resourceService.get('NEWSLETTERSIGNUPPOPUPTITLE'),
                        unsubscriptionNotes: this.resourceService.get('NEWSLETTERSIGNUPPOPUPUNSUBSCRIBENOTES'),
                        subscribeButtonLabel: this.resourceService.get('NEWSLETTERSIGNUPPOPUPSUBSCRIBEBUTTON'),
                        styles: {
                            'background-image': `url(${this.signUpPopupBackgroundImageUrl})`
                        },
                        confirm: function () {
                            this.showSuccess = true;
                        },
                        continue: function() {
                            this.defer.resolve({
                                result: 'confirm'
                            });
                        }
                    }
                })
                .catch(this._sendPopupClosedGAEvent.bind(this));
        }
    }

    angular.module('TR').service('signUpPopupService', SignUpPopupService);
}
